import React from 'react';
import { ArchonHeaderViewModel } from '../ArchonHeader/ArchonHeader';
import { ArchonFooterViewModel } from '../ArchonFooter/ArchonFooter';
import { GameViewModel } from '@resources/js/typings/viewModels/gameViewModel';
import { BuildsClassesAndSpecsPageViewModel } from '../../helpers/getBuildsClassesAndSpecsPageViewModels';
import { GameContextProvider } from '@resources/js/contexts/useGame';
import ArchonLayout, {
  Background,
  Container,
} from '../../layouts/ArchonLayout/ArchonLayout';
import ArchonTitle from '../ArchonTitle/ArchonTitle';
import Body from '@resources/js/components/Body/Body';
import Heading from '@resources/js/components/Heading/Heading';
import EnhancedMarkdown from '@resources/js/components/EnhancedMarkdown/EnhancedMarkdown';
import BuildsClassAndSpecBox from '@resources/js/components/BuildsClassAndSpecBox/BuildsClassAndSpecBox';
import styles from './ClassesAndSpecsPage.module.scss';
import LinkWrapper from '../LinkWrapper/LinkWrapper';
import Seo from '../Seo/Seo';

export type ClassesAndSpecsPageProps = {
  header: ArchonHeaderViewModel;
  footer: ArchonFooterViewModel;
  game: GameViewModel;
  buildsClassesAndSpecsPage: BuildsClassesAndSpecsPageViewModel;
};

export default function ClassesAndSpecsPage({
  game,
  header,
  footer,
  buildsClassesAndSpecsPage,
}: ClassesAndSpecsPageProps): JSX.Element {
  const {
    pageTitle,
    pageSubTitle,
    classesAndSpecs,
    archonTitleHeading,
    archonTitleBadgeLabel,
    archonTitleBadgeTooltip,
    seo,
  } = buildsClassesAndSpecsPage;
  return (
    <GameContextProvider game={game}>
      <ArchonLayout
        header={header}
        breadcrumbs={buildsClassesAndSpecsPage.breadcrumbs}
        footer={footer}
      >
        <Seo {...seo} game={game} />
        <Background />
        <Container>
          <ArchonTitle
            heading={archonTitleHeading}
            badgeLabel={archonTitleBadgeLabel}
            badgeTooltip={archonTitleBadgeTooltip}
          />
          <Body>
            <Heading level={2}>{pageTitle}</Heading>
            <EnhancedMarkdown markdown={pageSubTitle} wrapped={false} />
            <div className={styles.container}>
              {classesAndSpecs.map((classAndSpecs) => (
                <BuildsClassAndSpecBox
                  key={classAndSpecs.className}
                  className={classAndSpecs.className}
                  cssClassName={classAndSpecs.cssClassName}
                  specs={classAndSpecs.specs}
                  LinkWrapper={LinkWrapper}
                />
              ))}
            </div>
          </Body>
        </Container>
      </ArchonLayout>
    </GameContextProvider>
  );
}
